<template>
  <div class="special_home_container">
    <div class="special_box_bg">
      <img :src="backgroundImg" alt="">
    </div>
    <div class="special_box">
      <div class="special_logo">
        <!-- <img :src="require('@/assets/images/sudu.png')" alt=""> -->
      </div>
      <div class="special_title">
        <span v-text="detail.specialTitle"></span>
      </div>
      <div class="special_category" v-if="specialCategoryList.length > 1">
        <ul>
          <li :class="{'category_item':true, 'category_item_on': curCategoryId == item.id }" v-for="(item, index) in specialCategoryList" :key="index" v-text="item.name" @click="onTabClick(index)"></li>
        </ul>
      </div>
      <div class="category_content_list">
        <div class="category_content_swipe">
          <van-swipe :show-indicators="false" :loop="false" :effect="'fade'" @change="onChangeCategory" ref="categorySwipe">
            <van-swipe-item v-for="(group, index) in specialNewsList" :key="index">
              <div class="content_list">
                <van-swipe :show-indicators="false" :loop="false" vertical v-if="!!group.data" @change="onChangeItem">
                  <van-swipe-item v-for="(item,i) in group.data.list" :key="index+'-'+i">
                    <div class="news_item">
                      <div class="news_item_img">
                        <div class="img">
                          <img :src="item.listThumbnail" alt="" v-if="!!item.listThumbnail && item.listThumbnail.length>0" :onerror="imgLoadError(item)">
                          <img :src="require('@/assets/images/default_pic_16_9.png')" alt="" v-else>
                        </div>
                      </div>
                      <div class="news_item_detail">
                        <div class="news_item_title" v-text="item.title"></div>
                        <div class="news_item_info">
                          <span class="source" v-text="item.source" v-if="!!item.source && item.source.length>0"></span>
                          <span class="source" v-text="appName" v-else></span>
                          <span class="time" v-text="item.appPublishedTime"></span>
                        </div>
                        <div class="news_item_intro">
                          <!-- 活动 -->
                          <span v-text="item.introduction" v-if="item.contentType==1 && !!item.introduction && item.introduction.length>0"></span>
                          <span v-text="item.subhead" v-else-if="item.contentType==1 && !!item.subhead && item.subhead.length>0"></span>
                          <!-- 投票 -->
                          <!-- <span v-text="item.introduction" v-else-if="item.contentType==3"></span> -->
                          <!-- 直播 -->
                          <span v-text="item.introduction" v-else-if="item.contentType==4 && !!item.introduction && item.introduction.length>0"></span>
                          <span v-text="item.subhead" v-else-if="item.contentType==4 && !!item.subhead && item.subhead.length>0"></span>
                          <!-- 图文 -->
                          <span v-text="item.introduction" v-else-if="item.contentType==5 && !!item.introduction && item.introduction.length>0"></span>
                          <span v-text="item.subhead" v-else-if="item.contentType==5 && !!item.subhead && item.subhead.length>0"></span>
                          <!-- 图集 -->
                          <span v-text="item.introduction" v-else-if="item.contentType==6 && !!item.subhead && item.subhead.length>0"></span>
                          <!-- 广告 -->
                          <span v-text="item.subhead" v-else-if="item.contentType==8 && !!item.subhead && item.subhead.length>0"></span>
                          <!-- 视频 -->
                          <span v-text="item.summary" v-else-if="item.contentType==9 && !!item.summary && item.summary.length>0"></span>
                          <span v-text="item.subhead" v-else-if="item.contentType==9 && !!item.subhead && item.subhead.length>0"></span>
                          <!-- 问卷 -->
                          <span v-text="item.summary" v-else-if="item.contentType==10 && !!item.summary && item.summary.length>0"></span>
                          <span v-text="item.subhead" v-else-if="item.contentType==10 && !!item.subhead && item.subhead.length>0"></span>
                          <!-- 外链 -->
                          <!-- <span v-text="item.introduction" v-else-if="item.contentType==12"></span> -->
                        </div>
                        <div class="news_item_praise">
                          <span :class="{'praise':true,'praised':item.userLikes==1}" @click="onPraiseClick($event,item)" v-if="!!praiseIcon && item.likesSupport">
                            <img :src="praiseIcon.iconUrl_normal_1" alt="" v-if="item.likeType=='10' && item.userLikes==0">
                            <img :src="praiseIcon.iconUrl_press_1" alt="" v-else-if="item.likeType=='10' && item.userLikes==1">
                            <img :src="praiseIcon.iconUrl_normal_2" alt="" v-else-if="item.likeType=='11' && item.userLikes==0">
                            <img :src="praiseIcon.iconUrl_press_2" alt="" v-else-if="item.likeType=='11' && item.userLikes==1">
                            <img :src="praiseIcon.iconUrl_normal" alt="" v-else-if="item.likeType=='' && item.userLikes==0">
                            <img :src="praiseIcon.iconUrl_press" alt="" v-else-if="item.likeType=='' && item.userLikes==1">
                            <span class="praiseCount" v-text="item.praiseCount" v-if="!!item.praiseCount"></span>
                          </span>
                        </div>
                        <div class="news_item_next" v-if="i<group.data.list.length-1">
                          <img :src="require('@/assets/images/up.png')" alt="">
                        </div>
                      </div>
                    </div>
                  </van-swipe-item>
                </van-swipe>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import specialApi from "@/api/apis/special.js";
import commApi from "@/api/apis/common.js";
export default {
  name: "specialTemplate003",
  props: {
    contentId: {
      type: Number,
      default: null,
    },
    detail: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState("app", ["userInfo", "deviceId", "appName"]),
  },
  data() {
    return {
      praiseIcon: null, //点赞图标
      specialCategoryList: [], //专题内容分类
      specialNewsList: [], //专题内容列表
      backgroundImg: '', //背景图片
      curCategoryId: null,
      curCategoryIndex: 0, //当前分类下标
    };
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 获取点赞类型及相关图标 */
    getAppFunButtonConfigNew() {
      var _this = this;
      commApi
        .getAppFunButtonConfigNew(null)
        .then((res) => {
          if (res.suc == 1) {
            _this.praiseIcon = res.data.addTopBtn;
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取点赞状态 */
    getThumbsUpStatus(item) {
      var _this = this;
      var params = {
        contentType: item.contentType,
        contentId: item.originalId,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      commApi
        .queryThumbsUpStatus(params)
        .then((res) => {
          if (res.suc == 1) {
            let articleIndex = _this.specialNewsList[_this.curCategoryIndex].curArticleIndex;
            if (!!res.data) {
              _this.$set(_this.specialNewsList[_this.curCategoryIndex].data.list[articleIndex], "praiseCount", res.data.topCount);
              _this.$set(_this.specialNewsList[_this.curCategoryIndex].data.list[articleIndex], "userLikes", res.data.userLikes);
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 点赞、取消点赞 */
    onPraiseClick(event, item) {
      var _this = this;
      var target = event.currentTarget;
      let clsArray = target.classList;

      var params = {
        contentType: item.contentType,
        contentId: item.originalId,
      };
      if (!!_this.userInfo) {
        params.memberId = _this.userInfo.id;
      } else {
        params.deviceId = _this.deviceId;
      }
      if (clsArray.contains("praised")) {
        commApi
          .cancelThumbsUp(params)
          .then((res) => {
            if (res.suc == 1) {
              if (!!item.praiseCount && !!res.data.topCount) {
                item.praiseCount = res.data.topCount;
                item.userLikes = 0;
              }
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } else {
        commApi
          .giveThumbsUp(params)
          .then((res) => {
            if (res.suc == 1) {
              if (!!item.praiseCount && !!res.data.topCount) {
                item.praiseCount = res.data.topCount;
                item.userLikes = 1;
              }
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    /* 切换分类 */
    onTabClick(index) {
      this.$refs.categorySwipe.swipeTo(index);
    },
    /* 切换分类 */
    onChangeCategory(categoryIndex) {
      this.curCategoryId = this.specialCategoryList[categoryIndex].id;
      this.curCategoryIndex = categoryIndex;
      let articleIndex = this.specialNewsList[this.curCategoryIndex].curArticleIndex;
      let item = this.specialNewsList[this.curCategoryIndex].data.list[articleIndex];
      if (!!item) {
        let src = item.listThumbnail;
        if (!!src && src.length > 0) {
          this.backgroundImg = src;
        } else {
          this.backgroundImg = require('@/assets/images/default_pic_16_9.png');
        }
        this.getThumbsUpStatus(item);
      }
    },
    /* 切换稿件 */
    onChangeItem(articleIndex) {
      this.specialNewsList[this.curCategoryIndex].curArticleIndex = articleIndex;
      let item = this.specialNewsList[this.curCategoryIndex].data.list[articleIndex];
      if (!!item) {
        let src = item.listThumbnail;
        if (!!src && src.length > 0) {
          this.backgroundImg = src;
        } else {
          this.backgroundImg = require('@/assets/images/default_pic_16_9.png');
        }
        this.getThumbsUpStatus(item);
      }
    },
    /* 获取专题稿件分类 */
    getSpecialById() {
      var _this = this;
      var params = { contentId: _this.contentId };

      specialApi
        .getSpecialById(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.specialCategoryList = res.data.list;
            if (_this.specialCategoryList.length > 0) {
              _this.curCategoryId = _this.specialCategoryList[0].id;
            }
            for (var i = 0; i < _this.specialCategoryList.length; i++) {
              _this.specialNewsList.push({
                id: _this.specialCategoryList[i].id,
                data: null,
                curArticleIndex: 0,
              });
              _this.getSpecialContentsByClassifyId(
                _this.specialCategoryList[i].id
              );
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 根据专题内容分类Id获取专题内容列表 */
    getSpecialContentsByClassifyId(id) {
      var _this = this;
      var params = {
        currentPage: 0,
        pageSize: 20,
        contentClassifyId: id,
      };
      specialApi
        .getSpecialContentsByClassifyId(params)
        .then((res) => {
          if (res.suc == 1) {
            _this.specialNewsList.map(function (obj) {
              if (obj.id == id) {
                obj.data = res.data;
              }
            }, id);
            if (_this.specialNewsList.length > 0 && _this.specialNewsList[0].data != null && _this.specialNewsList[0].id == id) {
              if (!!_this.specialNewsList[0].data.list && _this.specialNewsList[0].data.list.length > 0) {
                _this.backgroundImg = _this.specialNewsList[0].data.list[0].listThumbnail;
                _this.getThumbsUpStatus(_this.specialNewsList[0].data.list[0]);
              }
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
  },
  created() {
    if (!!this.contentId) {
      this.getSpecialById(); //获取专题稿件分类
      this.getAppFunButtonConfigNew();
    }
  },
};
</script>
<style scoped lang="scss">
.special_home_container {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  .special_box_bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    filter: blur(12px) brightness(0.9);
    -webkit-filter: blur(12px) brightness(0.9);
    img {
      width: 100%;
      height: 100%;
      filter: blur(35px) brightness(0.7);
      -webkit-filter: blur(35px) brightness(0.7);
    }
  }
  .special_box {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    .special_logo {
      padding: 20px 20px 0;
      text-align: right;
    }
    .special_title {
      padding: 10px 20px 0;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
    }
    .special_category {
      padding: 10px 15px;
      ul {
        .category_item {
          display: inline-block;
          line-height: 24px;
          padding-left: 10px;
          padding-right: 10px;
          margin: 5px;
          border-radius: 12px;
          color: #fff;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
          &.category_item_on {
            background-color: #db0100;
          }
        }
      }
    }
    .category_content_list {
      width: 100%;
      .category_content_swipe {
        width: 100%;
        .content_list {
          width: 100%;
          padding: 0 20px;
          height: calc(56.25vw - 22.5px + 360px);
          .van-swipe {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            overflow: hidden;
            .news_item {
              height: calc(56.25vw - 22.5px + 360px);
              background-color: #fff;
              border-radius: 10px;
              overflow: hidden;
              .news_item_img {
                position: relative;
                width: 100%;
                height: 0;
                padding-bottom: 56.25%;
                overflow: hidden;
                .img {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  img {
                    object-fit: cover;
                    min-width: 100%;
                    min-height: 100%;
                  }
                }
              }
              .news_item_detail {
                position: relative;
                height: 360px;
                padding: 10px 15px 10px;
                .news_item_title {
                  color: #373737;
                  font-size: 20px;
                  font-weight: bold;
                }
                .news_item_info {
                  padding-top: 5px;
                  span {
                    line-height: 24px;
                    color: #b2b2b2;
                    font-size: 13px;
                    font-weight: bold;
                    &.source {
                      margin-right: 5px;
                    }
                  }
                }
                .news_item_intro {
                  height: 125px;
                  padding-top: 5px;
                  line-height: 24px;
                  overflow: hidden;
                  color: #292828;
                  font-size: 16px;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 5;
                  -webkit-box-orient: vertical;
                }
                .news_item_praise {
                  position: absolute;
                  left: 0;
                  bottom: 60px;
                  width: 100%;
                  text-align: center;
                  /deep/.praise {
                    display: inline-block;
                    &.praised {
                      color: #db1e06;
                    }
                    img {
                      display: block;
                      max-width: 30px;
                      max-height: 30px;
                    }
                    .praiseCount {
                      margin-top: 5px;
                    }
                  }
                }
                .news_item_next {
                  position: absolute;
                  bottom: 15px;
                  left: 0;
                  width: 100%;
                  height: 24px;
                  text-align: center;
                  -webkit-animation: MoveUpDown 1s linear infinite;
                  img {
                    display: inline-block;
                    max-width: 24px;
                    max-height: 24px;
                    margin: auto;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 500px) {
  .special_home_container {
    .special_box {
      left: calc(50% - 250px);
      width: 500px;
      .category_content_list {
        .category_content_swipe {
          .content_list {
            height: 618.75px;
            .van-swipe {
              .news_item {
                height: 618.75px;
              }
            }
          }
        }
      }
    }
  }
}
@-webkit-keyframes MoveUpDown {
  from {
    bottom: 15px;
  }
  to {
    bottom: 30px;
  }
}
</style>